export default __webpack_public_path__ + "static/media/743.0db31c28.png";